export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9759.345f6f22.jpg";